import schema from './schema.js'

const model = {
  title: '應收對帳單',
  schema: schema.recStatement,
}

export default {
  models: {
    recStatements: {
      ...model,
      views: {
        main: {
          data: {
            bundle: {
              receivables: { onRemove: 'setNull' },
            },
          },
          options: {
            salesOrders: {},
          },
        },
      },
    },
  },
}
